/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex;position:relative}[_nghost-%COMP%]   .filter-panel[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:flex-start;padding:10px;background-color:#f5f5f5;position:absolute;top:0;left:0;right:0}[_nghost-%COMP%]   .filter-panel[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-right:10px}[_nghost-%COMP%] > .grid[_ngcontent-%COMP%]{flex:auto;position:absolute;top:50px;bottom:0;left:0;right:0;display:flex}"];
export { styles as styles };
